import React, {useCallback, useEffect, useRef} from 'react';
import {SearchBox} from '../JobsView.styles';
export interface JobSearchProps {
    search?: string;
    setSearch: (value: string) => void;
    setJobResultsPage: (n: number) => void;
    searchLabel?: string;
}

export const SearchStandard = ({search, setSearch, setJobResultsPage, searchLabel}: JobSearchProps): JSX.Element => {
    const onChange = useCallback(
        (e) => {
            setSearch(e.target.value);
            setJobResultsPage(0);
        },
        [setSearch]
    );

    const searchInput = useRef<HTMLInputElement>(null);

    //Update width of search input to fit placeholder text (upto a max 300px)
    useEffect(() => {
        const input = searchInput.current;
        if (input) {
            const currentPlaceholderLength = input.getAttribute('placeholder')?.length?.toString();
            if (currentPlaceholderLength) {
                input.setAttribute('size', currentPlaceholderLength);
            }
        }
    }, [searchInput]);

    return (
        <SearchBox>
            <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.75146 9C4.75146 6.10522 7.11525 3.75 10.0417 3.75C12.9681 3.75 15.3319 6.10522 15.3319 9C15.3319 11.8948 12.9681 14.25 10.0417 14.25C7.11525 14.25 4.75146 11.8948 4.75146 9ZM10.0417 2.25C6.29628 2.25 3.25146 5.26736 3.25146 9C3.25146 12.7326 6.29628 15.75 10.0417 15.75C13.7871 15.75 16.8319 12.7326 16.8319 9C16.8319 5.26736 13.7871 2.25 10.0417 2.25ZM16.6105 14.4679C16.3166 14.176 15.8417 14.1776 15.5498 14.4714C15.2579 14.7653 15.2595 15.2402 15.5534 15.5321L18.5735 18.5321C18.8673 18.824 19.3422 18.8224 19.6341 18.5286C19.926 18.2347 19.9245 17.7598 19.6306 17.4679L16.6105 14.4679Z"
                    fill="#1C1C1C"
                />
            </svg>
            <input
                ref={searchInput}
                type="text"
                tabIndex={0}
                placeholder={searchLabel || 'Enter keywords'}
                value={search}
                onChange={onChange}
            />
        </SearchBox>
    );
};
